require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-software-engineer-india.json") })
        }
      }, "path---careers-software-engineer-india");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-software-engineer-india!./.cache/json/careers-software-engineer-india.json
// module id = 878
// module chunks = 231608221292675